import { forwardRef } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";

const badgeVariants = cva(
  "inline-flex w-fit items-center justify-center rounded px-1.5 py-0.5 text-xs font-semibold leading-4 tracking-[0.04px]",
  {
    variants: {
      variant: {
        // Organization Type Badges
        administrative: "bg-[rgba(255,255,255,0.9)] border border-[rgba(0,6,46,0.2)] text-[#1c2024]",
        regulatory: "bg-[rgba(0,85,199,0.04)] border border-[rgba(0,89,175,0.36)] text-[#213649]",
        test: "bg-[rgba(213,149,0,0.05)] border border-[rgba(150,103,0,0.4)] text-[#3c372b]",
        testing: "bg-[rgba(213,149,0,0.05)] border border-[rgba(150,103,0,0.4)] text-[#3c372b]",
        // Permission Badges
        admin: "bg-[rgba(0,0,51,0.06)] text-[#1c2024]",
        readWrite: "bg-[rgba(68,0,238,0.06)] text-[#2f265f]",
        readOnly: "bg-[rgba(0,85,170,0.08)] text-[#003261]",
        writeOnly: "bg-[rgba(0,151,0,0.09)] text-[#203c25]",
        // Search Badges
        search: "bg-[rgba(0,170,123,0.11)] text-[#1e3933]",
        nosearch: "bg-[rgba(220,38,38,0.11)] text-[#991b1b]",
        // Inherit Badge
        inherits: "bg-[rgba(139,141,152,0.1)] border border-[rgba(139,141,152,0.3)] text-[#60646c]",
      },
    },
    defaultVariants: {
      variant: "administrative",
    },
  }
);

export type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants>;

const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(badgeVariants({ variant, className }))}
      {...props}
    />
  )
);

Badge.displayName = "Badge";

export { Badge, badgeVariants };

